import { monoPalette } from "@/styles/themes/colors/palettes";

export const aliasDarkgray = {
  main: monoPalette.dark[54],
};
export type AliasDarkgrayScheme = "darkgray";
export type AliasDarkgray = `${AliasDarkgrayScheme}.${keyof typeof aliasDarkgray}`;
